module.exports = "<span id=\"current-env\" *ngIf=\"currentEnv!=null\" class=\"primary-color\">You are currently logged in into {{currentEnv}}</span>\n"